module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-chevrolet.97a93060.png";